import React from 'react'
import ArticleHero from './ArticleHero'
import PublishArticles from './PublishArticles'
import NewsPaper from './NewsPaper'
import Empowering from './Empowering'

const ArticlesPage = () => {
  return (
      <>
          <ArticleHero />
          <PublishArticles />
          <NewsPaper />
          <Empowering/>
      </>
  )
}

export default ArticlesPage